import axios, { AxiosRequestConfig } from 'axios'
import { authHeader } from '../helpers/authHeader'

interface Options<BodyT> extends AxiosRequestConfig {
  body?: BodyT
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' ,
  headers?: {
    icaNowSafeUpload?: string
    [key: string]: any
  }
}

export async function fetchData<T>(requestUrl: string, options: Options<T>) {
  const authHeaders = authHeader()

  const headers = {
    ...authHeaders
  }

  try {
    if (options?.method === 'POST') {
      const postHeaders = {
        ...headers,
        ...(options.headers?.icaNowSafeUpload && { 'x-safe-upload': options.headers.icaNowSafeUpload }),
      }
      return await axios.post(requestUrl, options.body, {
        headers: postHeaders,
      })
    } else if (options?.method === 'PUT') {
      return await axios.put(requestUrl, options.body, {
        headers,
      })
    } else if (options?.method === 'DELETE') {
      return await axios.delete(requestUrl, {
        headers,
        data: options?.body
      })
    } else {
      return await axios.get(requestUrl, {
        headers,
      })
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      
      if (error?.response?.status === 401) {
        localStorage.removeItem('media')
        window.location.href = '/'
      }
      return error.response
    } else {
      console.log(error)
    }
  }
}